import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { DateTimeStr, debugTime, Timestamp, toTimestamp } from '@mi-front/core';
import debugFn from 'debug';
import { useCallback } from 'react';
import { AuditMatch } from '../types';

const debug = debugFn('audit');

/**
 * Hook to play an audit match
 */
export function usePlayAuditMatch(match: AuditMatch) {
  const play = usePlaybackPlay();

  return useCallback(async () => {
    await play({
      startTs: toTimestamp(match.datetime),
      stopTs: (toTimestamp(match.datetime) + match.audio!.duration) as Timestamp,
    });
  }, [match, play]);
}

/**
 * Hook to play a transcription at a specific time
 * Returns a function that takes a DateTimeStr and plays it
 */
export function usePlayTranscription() {
  const play = usePlaybackPlay();

  return useCallback(
    async (time: DateTimeStr) => {
      debug('Play transcription at %s', debugTime(time));

      const startTs = toTimestamp(time);

      play({
        startTs,
      });
    },
    [play],
  );
}
